import React, { useEffect, useState } from "react";
import { Col, Card, Row, Container, Nav } from "react-bootstrap";
import useFetch from "../hooks/useFetch";
import ContentSlider from "../utilities/ContentSlider";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function VideoBookSection() {
  const [videoToShow, setVideoToShow] = useState(null);
  const [booksToShow, setBooksToShow] = useState(null);
  const videos = useFetch("sitemanagement/videos/");
  const books = useFetch("sitemanagement/books/");

  useEffect(() => {
    const v = videos?.filter(
      (video) => video.purpose.toLowerCase() === "sunday video"
    );

    const b = books?.filter(
      (book) => book.purpose.toLowerCase() === "advertisement"
    );
    setVideoToShow(v);
    setBooksToShow(b);

    console.log(b)
  }, [books, videos]);

  return (
    <Container fluid="xxl">
      <Row className="my-5">
        <Col xs={12} md={7} className="mb-3 mb-md-0">
          <Card className="video-card border-0">
            {!videoToShow ? (
              <SkeletonTheme color="#e1e1e1" highlightColor="#f2f2f2">
                <Skeleton
                  height={275}
                  count={1}
                  style={{ borderRadius: "10px" }}
                />
              </SkeletonTheme>
            ) : (
              <ContentSlider items={videoToShow} />
            )}
          </Card>
        </Col>
        <Col xs={12} md={5} className="d-flex align-items-stretch">
       
          {booksToShow && booksToShow.length > 0 && booksToShow[0] ? (
            <Card
              className="book-card"
              style={{
                width: "100%",
              }}
            >
              <>
                <Card.Img
                  src={`${booksToShow[0].book_image.replace(
                    "media",
                    "static"
                  )}`}
                  id={booksToShow[0].id}
                  className="book-image"
                />
                <Card.Body className="d-flex flex-column justify-content-center">
                  <Nav.Link
                    href={booksToShow[0].eshop_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white text-center button-gradient"
                    style={{
                      border: "none",
                      borderRadius: "5px",
                      fontSize: "1.2rem",
                      marginTop: "10px",
                      padding: "10px",
                    }}
                  >
                    Shop Now
                  </Nav.Link>
                </Card.Body>
              </>
            </Card>
          ) : (
            // Render a placeholder or a message when booksToShow is empty
            <Card className="book-card" style={{ width: "100%" }}>
              <Card.Body>
                <p>No books available at the moment.</p>
              </Card.Body>
            </Card>
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default VideoBookSection;
